import { z } from 'zod';
import { baseString } from './core/primitives';
import { str, emptyToUndefined } from './core/helpers';

// ── Constants ───────────────────────────────────────────────────────────────
const DRAFT_NAME_MAX_LENGTH = 255;
const DRAFT_DESCRIPTION_MAX_LENGTH = 2000;

// ── Schema factories ───────────────────────────────────────────────────────

export const createWorkflowDraftSchema = (t) =>
  z.object({
    name: z.preprocess(
      str,
      baseString.min(1, t('validation.workflowDraft.name.required')).max(
        DRAFT_NAME_MAX_LENGTH,
        t('validation.workflowDraft.name.maxLength', {
          max: DRAFT_NAME_MAX_LENGTH,
        })
      )
    ),
    description: baseString
      .max(
        DRAFT_DESCRIPTION_MAX_LENGTH,
        t('validation.workflowDraft.description.maxLength', {
          max: DRAFT_DESCRIPTION_MAX_LENGTH,
        })
      )
      .optional(),
  });

export const updateWorkflowDraftSchema = (t) =>
  z.object({
    name: z
      .preprocess(
        str,
        baseString.min(1, t('validation.workflowDraft.name.required')).max(
          DRAFT_NAME_MAX_LENGTH,
          t('validation.workflowDraft.name.maxLength', {
            max: DRAFT_NAME_MAX_LENGTH,
          })
        )
      )
      .optional(),
    description: emptyToUndefined(
      baseString
        .max(
          DRAFT_DESCRIPTION_MAX_LENGTH,
          t('validation.workflowDraft.description.maxLength', {
            max: DRAFT_DESCRIPTION_MAX_LENGTH,
          })
        )
        .optional()
    ),
  });

export { DRAFT_NAME_MAX_LENGTH, DRAFT_DESCRIPTION_MAX_LENGTH };
